<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen"
							  :reportOpen="reportOpen"
				></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1><span v-if="!contact.surnames">{{ $t('New_contact') }}</span><span
							v-else>{{ $t('Contact') }}: {{ contact.name }} {{ contact.surnames
						}}</span> <span v-if="contact.dirty">*</span></h1>
					<message
							v-if="contact.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(contact.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(contact.date_modified) }}</p>
					</div>
					<div>
						<vue-tabs>
							<v-tab :title="data_text">
								<div class="tab_content">
						<form class="bt-form">
							<div class="form-section">
								<h3>{{ $t('Person_type') }}</h3>
								<div class="field-container">

									<div class="ms-container">
										<label class="field__group__label">{{ $t('Person_type') }}</label>
										<multiselect placeholder=""
													 :value="value"
													 :options="personTypeOptions"
													 track-by="id"
													 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
													 :searchable="false"
													 v-model="contact.person_type"
													 @input="set_contact_person_type"></multiselect>
									</div>
								</div>
							</div>
							<div v-if="contact.person_type">
								<div class="form-section">
									<h3>{{ $t('Data') }}</h3>
									<div class="field-container">
										<div class="ms-container" v-if="contact.person_type.id === 1">
											<label class="field__group__label">{{ $t('Title') }}</label>
											<multiselect placeholder=""
														 :value="value"
														 :options="honorificTitleOptions"
														 track-by="id"
														 :label="(currentLocale === 'ca')?
											 'abb_ca': (currentLocale === 'en')?
											 'abb_en': 'abb_es'"
														 :searchable="false"
														 v-model="contact.title"
														 @input="set_contact_title"></multiselect>
										</div>
										<div class="field__group">
											<label class="field__group__label">{{ $t('Name') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.name"
												   @input="set_contact_name">
										</div>

										<div class="field__group" v-if="contact.person_type.id === 1">
											<label class="field__group__label">{{ $t('Surnames') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.surnames"
												   @input="set_contact_surnames">
										</div>
										<div class="field__group">
											<label class="field__group__label">{{ $t('TIN') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.tin"
												   @input="set_contact_tin">
										</div>
									</div>
								</div>
								<div class="form-section" v-if="contact.person_type.id === 1">
									<h3>{{ $t('Organization_s_Company') }}</h3>
									<div class="field-container">

										<div class="field__group">
											<label class="field__group__label">{{ $t('Organization_s_Company')
												}}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.organization"
												   @input="set_contact_organization">
										</div>

									</div>
								</div>
								<div class="form-section" v-if="contact.person_type.id === 2">
									<h3>{{ $t('Representative') }}</h3>
									<div class="field-container">

										<div class="field__group">
											<label class="field__group__label">{{ $t('Representative') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.representative"
												   @input="set_contact_representative">
										</div>
										<div class="field__group">
											<label class="field__group__label">{{ $t('Representative_TIN') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.representative_tin"
												   @input="set_contact_representative_tin">
										</div>

									</div>
								</div>
								<div class="form-section">
									<h3>{{ $t('E-mail_addresses') }}</h3>
									<div class="field-container">
										<div class="field__group">
											<label class="field__group__label">{{ $t('Main_email') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.main_email"
												   @input="set_contact_main_email">
										</div>
									</div>
									<!--
									<div>
										<div @click.prevent="onCreateNewEmailAddress"
											 style="width: fit-content; margin-left: auto">
											<icon-button icon="plus-circle" :text="new_email_button_text"
														 icon_color="black"
														 text_color="black" border_color="lightgray"></icon-button>
										</div>
									</div>
									<div v-if="object_length(contact_emailaddresses) > 0">
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell" layout="row">
												<input type="text" :placeholder="filter_placeholder" self="size-x1"
													   v-model="email_table.filter"
													   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
													   data-step="9" data-position="top">
											</div>
										</div>
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell">
												<paginator :source="object_to_array(contact_emailaddresses)"
														   :page-size="10"
														   :filter="email_table.filter"
														   data-intro="Use the paginator to page data for easier viewing"
														   data-step="10"
														   data-position="top">
													<template scope="page">
														<datatable id="data-table-email"
																   :source="page.data"
																   :filterable="false"
																   :striped="email_table.striped"
																   :editable="email_table.editable"
																   :line-numbers="email_table.lineNumbers">
															<datatable-column
																	v-for="column in email_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:formatter="column.formatter">
															</datatable-column>
															<datatable-column id="actions-email" :label="actions_text"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>
															<template slot="actions-email" scope="cell">
																<a @click="editEmailAddress(cell.row)"
																   style="margin-right: 2rem; cursor: pointer;">
																	<icon name="pencil" scale="1" color="gray"></icon>
																</a>
																<a @click="deleteEmailAddress(cell.row)"
																   style="cursor: pointer;">
																	<icon name="trash-o" scale="1" color="gray"></icon>
																</a>
															</template>
														</datatable>
													</template>
												</paginator>
											</div>
										</div>
									</div>


								</div>
								<div class="form-section">
									<h3>{{ $t('Telephone_numbers') }}</h3>

									<!--
									<div>
										<div @click.prevent="onCreateNewTelephoneNumber"
											 style="width: fit-content; margin-left: auto">
											<icon-button icon="plus-circle" :text="new_telephone_button_text"
														 icon_color="black"
														 text_color="black" border_color="lightgray"></icon-button>
										</div>
									</div>
									-->
									<!--
									<div v-if="object_length(contact_telephonenumbers) > 0">
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell" layout="row">
												<input type="text" :placeholder="filter_placeholder" self="size-x1"
													   v-model="telephone_table.filter"
													   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
													   data-step="9" data-position="top">
											</div>
										</div>
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell">
												<paginator :source="object_to_array(contact_telephonenumbers)"
														   :page-size="10"
														   :filter="telephone_table.filter"
														   data-intro="Use the paginator to page data for easier viewing"
														   data-step="10"
														   data-position="top">
													<template scope="page">
														<datatable id="data-table-telephone"
																   :source="page.data"
																   :filterable="false"
																   :striped="telephone_table.striped"
																   :editable="telephone_table.editable"
																   :line-numbers="telephone_table.lineNumbers">
															<datatable-column
																	v-for="column in telephone_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:formatter="column.formatter">
															</datatable-column>
															<datatable-column id="actions-telephone"
																			  :label="actions_text"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>
															<template slot="actions-telephone" scope="cell">
																<a @click="editTelephoneNumber(cell.row)"
																   style="margin-right: 2rem; cursor: pointer;">
																	<icon name="pencil" scale="1" color="gray"></icon>
																</a>
																<a @click="deleteTelephoneNumber(cell.row)"
																   style="cursor: pointer;">
																	<icon name="trash-o" scale="1" color="gray"></icon>
																</a>
															</template>
														</datatable>
													</template>
												</paginator>
											</div>
										</div>
									</div>
-->
								</div>
								<div class="form-section">
									<h3>{{ $t('Addresses') }}</h3>
									<div class="field__group">
										<label class="field__group__label">{{ $t('Complete_fiscal_address') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="contact.complete_fiscal_address"
											   @input="set_contact_complete_fiscal_address">
									</div>
									<!--
									<div>
										<div @click.prevent="onCreateNewAddress"
											 style="width: fit-content; margin-left: auto">
											<icon-button icon="plus-circle" :text="new_address_button_text"
														 icon_color="black"
														 text_color="black" border_color="lightgray"></icon-button>
										</div>
									</div>
									<div v-if="object_length(contact_addresses) > 0">
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell" layout="row">
												<input type="text" :placeholder="filter_placeholder" self="size-x1"
													   v-model="address_table.filter"
													   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
													   data-step="9" data-position="top">
											</div>
										</div>
										<div class="grid-row" layout="row top-stretch">
											<div class="grid-cell">
												<paginator :source="object_to_array(contact_addresses)"
														   :page-size="10"
														   :filter="address_table.filter"
														   data-intro="Use the paginator to page data for easier viewing"
														   data-step="10"
														   data-position="top">
													<template scope="page">
														<datatable id="data-table-main"
																   :source="page.data"
																   :filterable="false"
																   :striped="address_table.striped"
																   :editable="address_table.editable"
																   :line-numbers="address_table.lineNumbers">
															<datatable-column
																	v-for="column in address_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:formatter="column.formatter">
															</datatable-column>
															<datatable-column id="actions" :label="actions_text"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>
															<template slot="actions" scope="cell">
																<a @click="editAddress(cell.row)"
																   style="margin-right: 2rem; cursor: pointer;">
																	<icon name="pencil" scale="1" color="gray"></icon>
																</a>
																<a @click="deleteAddress(cell.row)"
																   style="cursor: pointer;">
																	<icon name="trash-o" scale="1" color="gray"></icon>
																</a>
															</template>
														</datatable>
													</template>
												</paginator>
											</div>
										</div>
									</div>
-->
								</div>

								<div class="form-section">
									<h3>{{ $t('Telephone_numbers') }}</h3>
									<div class="field-container">
										<div class="field__group">
											<label class="field__group__label">{{ $t('Main_telephonenumber') }}</label>
											<input class="field__group__input"
												   type="text"
												   spellcheck="false"
												   v-model="contact.main_telephonenumber"
												   @input="set_contact_main_telephonenumber">
										</div>
									</div>
								</div>


							</div>
							<div>
								<hr>
							</div>
							<div>
								<div @click.prevent="onGoBack" style="width: fit-content; margin-left: auto">
									<icon-button icon="chevron-left" :text="goback_button_text"
												 icon_color="black"
												 text_color="black" border_color="lightgray"></icon-button>
								</div>
							</div>
							<div>
								<div @click.prevent="onSaveCurrentContact({goback: true})"
									 style="width: fit-content; margin-left: auto">
									<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
												 text_color="white" border_color="#006bc5"
												 background_color="#0087F8"></icon-button>
								</div>
							</div>
							<message
									v-if="contact.dirty"
									:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
									border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
							</message>
						</form>
								</div>
							</v-tab>
							<v-tab :title="quotes_text">
								<div class="tab_content">


									<form class="bt-form">
										<div class="form-section">
											<h3>{{ $t('Quotes_requested_by') }} {{ this.contact.complete_name }}</h3>
											<div v-if="object_length(contact_appraisalquotes) > 0">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder" self="size-x1"
															   v-model="appraisalquote_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<paginator :source="object_to_array(contact_appraisalquotes)"
																   :page-size="10"
																   :filter="appraisalquote_table.filter"
																   data-intro="Use the paginator to page data for easier viewing"
																   data-step="10"
																   data-position="top">
															<template scope="page">
																<datatable id="data-table-appraisalquotes"
																		   :source="page.data"
																		   :filterable="false"
																		   :striped="appraisalquote_table.striped"
																		   :editable="appraisalquote_table.editable"
																		   :line-numbers="appraisalquote_table.lineNumbers">
																	<datatable-column
																			v-for="column in appraisalquote_table.columns"
																			:id="column.id"
																			:label="column.label"
																			:width="column.width"
																			:sortable="column.sortable"
																			:groupable="column.groupable"
																			:formatter="column.formatter">
																	</datatable-column>
																	<datatable-column id="actions-appraisalquotes" :label="actions_text"
																					  :sortable="false"
																					  :groupable="false"></datatable-column>
																	<template slot="actions-appraisalquotes" scope="cell">
																		<a @click="editAppraisalQuote(cell.row)"
																		   style="margin-right: 2rem; cursor: pointer;">
																			<icon name="pencil" scale="1" color="gray"></icon>
																		</a>
																	</template>
																</datatable>
															</template>
														</paginator>
													</div>
												</div>
											</div>
											<div v-else="">
												{{ $t('No_records') }}.
											</div>
										</div>
									</form>
								</div>
							</v-tab>
							<v-tab :title="invoices_text">
								<div class="tab_content">
								</div>
							</v-tab>
							<v-tab :title="appraisalreports_text">
								<div class="tab_content">
								</div>
							</v-tab>
						</vue-tabs>
					</div>


					<!--<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import router from '../../../router'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Message from '../../../components/Message.vue'
    import SuccessMessage from '../../../components/SuccessMessage.vue'

    import honorificTitleOptions from '../../../options/honorific_titles'
    import personTypeOptions from '../../../options/person_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'contact-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            data_text: Vue.i18n.translate('Data'),
            quotes_text: Vue.i18n.translate('Quotes'),
            invoices_text: Vue.i18n.translate('Invoices'),
            appraisalreports_text: Vue.i18n.translate('Appraisal_reports'),
            new_address_button_text: Vue.i18n.translate('Add_address'),
            new_email_button_text: Vue.i18n.translate('Add_other_email'),
            new_telephone_button_text: Vue.i18n.translate('Add_telephone_number'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_back'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            value: null,
            ms_placeholder: Vue.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions,
            personTypeOptions,
            address_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'street_name',
                        label: Vue.i18n.translate('Street_name'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'street_number',
                        label: Vue.i18n.translate('Street_number'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'municipality.name_ine',
                        label: Vue.i18n.translate('Municipality'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            email_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'address',
                        label: Vue.i18n.translate('Address'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            telephone_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'prefix',
                        label: Vue.i18n.translate('Prefix'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'number',
                        label: Vue.i18n.translate('Number'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            appraisalquote_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'quotedate',
                        label: Vue.i18n.translate('Date'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'full_number',
                        label: Vue.i18n.translate('Quote'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            }
        }),

        created () {

        },

        components: {
            Bar,
            Message,
            SuccessMessage,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
			SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'address',
                'emailaddress',
                'telephonenumber',
                'contact',
                'contact_addresses',
                'contact_emailaddresses',
                'contact_telephonenumbers',
				'contact_appraisalinvoices',
				'contact_appraisalquotes',
				'contact_appraisalreports',
				'contact'
            ])
        },

        created () {
            this.FETCH_CONTACT_ADDRESSES({path: 'contact_addresses' + '/' + this.$route.query.id + '/'})
                .then(() => {
                    this.FETCH_CONTACT_TELEPHONENUMBERS({path: 'contact_telephonenumbers' + '/' + this.$route.query.id + '/'})
                        .then(() => {
                            this.FETCH_CONTACT_EMAILADDRESSES({path: 'contact_emailaddresses' + '/' + this.$route.query.id + '/'})
                                .then(() => {
                                    this.FETCH_CONTACT_APPRAISALINVOICES({path: 'contacts' + '/' + this.$route.query.id + '/' + 'appraisalinvoices' + '/'})
                                        .then(() => {
                                            this.FETCH_CONTACT_APPRAISALQUOTES({path: 'contacts' + '/' + this.$route.query.id + '/' + 'appraisalquotes' + '/'})
                                                .then(() => {
                                                    this.FETCH_CONTACT_APPRAISALREPORTS({path: 'contacts' + '/' + this.$route.query.id + '/' + 'appraisalreports' + '/'})
                                                        .then(() => {
                                                            this.master_loading = false
                                                        })
                                                })
                                        })
                                })
                        })
                })
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_ADDRESS',
                    'CREATE_NEW_EMAILADDRESS',
                    'CREATE_NEW_TELEPHONENUMBER',
                    'DELETE_ADDRESS',
                    'DELETE_EMAILADDRESS',
                    'DELETE_TELEPHONENUMBER',
                    'FETCH_CONTACT_ADDRESSES',
                    'FETCH_CONTACT_EMAILADDRESSES',
                    'FETCH_CONTACT_TELEPHONENUMBERS',
                    'FETCH_CONTACT_APPRAISALINVOICES',
                    'FETCH_CONTACT_APPRAISALQUOTES',
                    'FETCH_CONTACT_APPRAISALREPORTS',
                    'RESET_ADDRESS',
                    'RESET_EMAILADDRESS',
                    'RESET_TELEPHONENUMBER',
                    'SET_ADDRESS',
                    'SET_EMAILADDRESS',
                    'SET_TELEPHONENUMBER',
                    'SET_APPRAISALQUOTE',
                    'SET_CONTACT_ADDRESSES',
                    'SET_CONTACT_MAIN_EMAIL',
                    'SET_CONTACT_NAME',
                    'SET_CONTACT_ORGANIZATION',
                    'SET_CONTACT_PERSON_TYPE',
                    'SET_CONTACT_REPRESENTATIVE',
                    'SET_CONTACT_REPRESENTATIVE_TIN',
                    'SET_CONTACT_SURNAMES',
                    'SET_CONTACT_EMAILADDRESSES',
                    'SET_CONTACT_TELEPHONENUMBERS',
                    'SET_CONTACT_TIN',
                    'SET_CONTACT_TITLE',
                    'SET_CONTACT_COMPLETE_NAME',
                    'SET_CONTACT_COMPLETE_FISCAL_ADDRESS',
                    'SET_CONTACT_MAIN_TELEPHONENUMBER',

                    'UPDATE_CONTACT'
                ]),
            set_contact_addresses: _.debounce(function (e) {
                this.SET_CONTACT_ADDRESSES(e.target.value)
            }, 1000),
            set_contact_main_email: _.debounce(function (e) {
                this.SET_CONTACT_MAIN_EMAIL(e.target.value)
            }, 1000),
            set_contact_main_telephonenumber: _.debounce(function(e){
                this.SET_CONTACT_MAIN_TELEPHONENUMBER(e.target.value)
            }, 1000),
            set_contact_name: _.debounce(function (e) {
                let name = e.target.value
				let surnames = ''
				if(this.contact.surnames){
                    surnames = this.contact.surnames
				}
				let complete_name = surnames + ', ' + name
                if(!surnames){
                    complete_name = name
                }
                this.SET_CONTACT_NAME(name)
                this.SET_CONTACT_COMPLETE_NAME(complete_name)
            }, 1000),
            set_contact_organization: _.debounce(function (e) {
                this.SET_CONTACT_ORGANIZATION(e.target.value)
            }, 1000),
            set_contact_person_type: _.debounce(function (e) {
                this.SET_CONTACT_PERSON_TYPE(e)
            }, 1000),
            set_contact_representative: _.debounce(function (e) {
                this.SET_CONTACT_REPRESENTATIVE(e.target.value)
            }, 1000),
            set_contact_representative_tin: _.debounce(function (e) {
                this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value)
            }, 1000),
            set_contact_surnames: _.debounce(function (e) {
                let surnames = e.target.value
                let name = ''
                if(this.contact.name){
                    name = this.contact.name
                }
                let complete_name = surnames + ', ' + name
                if(!surnames){
                    complete_name = name
                }
                this.SET_CONTACT_SURNAMES(surnames)
                this.SET_CONTACT_COMPLETE_NAME(complete_name)
            }, 1000),
            set_contact_emailaddresses: _.debounce(function (e) {
                this.SET_CONTACT_EMAILADDRESSES(e.target.value)
            }, 1000),
            set_contact_telephonenumbers: _.debounce(function (e) {
                this.SET_CONTACT_TELEPHONENUMBERS(e.target.value)
            }, 1000),
            set_contact_tin: _.debounce(function (e) {
                this.SET_CONTACT_TIN(e.target.value)
            }, 1000),
            set_contact_title: _.debounce(function (e) {
                this.SET_CONTACT_TITLE(e)
            }, 1000),
            set_contact_complete_fiscal_address: _.debounce(function(e){
                this.SET_CONTACT_COMPLETE_FISCAL_ADDRESS(e.target.value)
            }, 500),
            onCreateNewAddress: function () {
                // console.log('hey')
                // console.log('contact: ')
                // console.log(this.contact)
                this.RESET_ADDRESS().then((res) => {
                    this.CREATE_NEW_ADDRESS({
                        path: 'contact_addresses' + '/' + this.contact.id + '/',
                        key: this.contact.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'addresses' + '/'
                    }).then((res) => {
                        this.$router.push({name: 'realestate-editor', query: {id: this.address.id}})
                    })
                })
            },
            onCreateNewEmailAddress: function () {
                // console.log('hey')
                // console.log('contact: ')
                // console.log(this.contact)
                this.RESET_EMAILADDRESS().then((res) => {
                    this.CREATE_NEW_EMAILADDRESS({
                        path: 'contact_emailaddresses' + '/' + this.contact.id + '/',
                        key: this.contact.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'emailaddresses' + '/'
                    }).then((res) => {
                        this.$router.push({name: 'emailaddress-editor', query: {id: this.emailaddress.id}})
                    })
                })

            },
            onCreateNewTelephoneNumber: function () {
                // console.log('hey')
                // console.log('contact: ')
                // console.log(this.contact)
                this.RESET_TELEPHONENUMBER().then((res) => {
                    this.CREATE_NEW_TELEPHONENUMBER({
                        path: 'contact_telephonenumbers' + '/' + this.contact.id + '/',
                        key: this.contact.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'telephonenumbers' + '/'
                    }).then((res) => {
                        this.$router.push({name: 'telephonenumber-editor', query: {id: this.telephonenumber.id}})
                    })
                })

            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onSaveCurrentContact: function (data) {
                // console.log('contact.id: ')
                // console.log(this.contact.id)
                this.UPDATE_CONTACT({
                    object: this.contact,
                    path: 'contacts' + '/' + this.contact.id
                }).then((res) => {
                    if (data.goback) {
                        router.go(-1)
                    }
                })
            },
            editAddress: function (entity) {
                // console.log('edit realestate...')
                this.SET_ADDRESS({path: 'contact_addresses' + '/' + this.contact.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'realestate-editor', query: {id: entity.id}})

                })
            },
            editEmailAddress: function (entity) {
                this.SET_EMAILADDRESS({path: 'contact_emailaddresses' + '/' + this.contact.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'emailaddress-editor', query: {id: entity.id}})

                })
            },
            editTelephoneNumber: function (entity) {
                this.SET_TELEPHONENUMBER({path: 'contact_telephonenumbers' + '/' + this.contact.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'telephonenumber-editor', query: {id: entity.id}})

                })
            },
            deleteAddress: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.street_name + ', ' + entity.street_number + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_ADDRESS({
                        path: 'contact_addresses' + '/' + this.contact.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'addresses' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_CONTACT_ADDRESSES({path: 'contact_addresses' + '/' + this.$route.query.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            deleteEmailAddress: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + ', ' + entity.address + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_EMAILADDRESS({
                        path: 'contact_emailaddresses' + '/' + this.contact.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'emailaddresses' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_CONTACT_EMAILADDRESSES({path: 'contact_emailaddresses' + '/' + this.$route.query.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            deleteTelephoneNumber: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + ', ' + entity.number + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_TELEPHONENUMBER({
                        path: 'contact_telephonenumbers' + '/' + this.contact.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'contacts' + '/' + this.contact.id + '/' + 'telephonenumbers' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_CONTACT_TELEPHONENUMBERS({path: 'contact_telephonenumbers' + '/' + this.$route.query.id + '/'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            editAppraisalQuote: function (entity) {
                this.SET_APPRAISALQUOTE({path: 'appraisalquotes' + '/' + entity.id}).then((res) => {
                    this.$router.push({name: 'appraisalquote-editor', query: {id: entity.id}})
                })
            },
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit contact'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// ContactEditor.vue?53282519